import { ColumnsType } from 'antd/lib/table';
import { InvoiceDto } from 'common/dto/generated/InvoiceDto';
import { InvoiceFilteredColumns } from './InvoiceColumns';

export const InvoiceAllColumns: ColumnsType<InvoiceDto> = [
  InvoiceFilteredColumns.isPaper,
  { ...InvoiceFilteredColumns.issuedDate, fixed: 'left' },
  InvoiceFilteredColumns.expiresAt,
  InvoiceFilteredColumns.state,
  InvoiceFilteredColumns.protocol,
  InvoiceFilteredColumns.protocolDate,
  InvoiceFilteredColumns.cig,
  InvoiceFilteredColumns.supplierName,
  InvoiceFilteredColumns.supplierFiscal,
  InvoiceFilteredColumns.issuedNumber,
  InvoiceFilteredColumns.invoiceTypeCode,
  InvoiceFilteredColumns.totalAmount
];
